import { connect } from 'react-redux';
import { getHeading, getCopySections } from 'Seo/selectors';
import CopySectionsView from './copy_sections_view';

const mapStateToPros = (state) => ({
  heading: getHeading(state),
  copySections: getCopySections(state),
});

export default connect(mapStateToPros)(CopySectionsView);
